import { Component, Input } from '@angular/core';
import { AnnotationType } from '@se/models';

import { LayerViewModel } from '../view-models/layer-viewmodel';

import { CssMediaService } from '../../lib/media.service';
import { MainMeasuresService } from '../utils/main-measures.service';
import { SeFlatPanelComponent } from '../se-flatpanel/se-flatpanel.component';
import { NgClass, NgForOf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'ecg-summary',
    templateUrl: './ecg-summary.component.html',
    styleUrls: ['./ecg-summary.component.css', './ecg-summary.component.16_9.css'],
    standalone: true,
    imports: [SeFlatPanelComponent, NgClass, TranslatePipe, NgForOf],
})
export class EcgSummaryComponent {
    // Data Members

    @Input()
    showConclusion: boolean = true;

    constructor(
        public cssMediaService: CssMediaService,
        public mainMeasuresService: MainMeasuresService,
    ) {}

    private _layer: LayerViewModel | null = null;

    get layer() {
        return this._layer;
    }

    // Constructor

    @Input()
    set layer(layer: LayerViewModel | null) {
        if (!layer) return;
        this._layer = layer;

        this.updateMeasures();
    }

    // private functions

    private updateMeasures() {
        if (this._layer == null || this._layer.ecgData == null) return;

        let valueAnnotations = this._layer.ecgData.originalWaveform.annotations.filter(
            (annotation) => annotation.type == AnnotationType.VALUE,
        );
        this.mainMeasuresService.extracts(valueAnnotations);
    }
}
